import { PackageType } from '../../api/package';
import classNames from 'classnames';
import { BLANK_TEXT } from '../../utils';
import Button from '../shared/buttons/button';
import { useState } from 'react';
import { useAddToCart, useContainPackage, useRemoveFromCart } from '../../context/cart/hooks';
import Field from '../shared/field';

export type PackageProps = { packageData: PackageType };

function Package({ packageData }: PackageProps) {
  const [showMore, setShowMore] = useState(false);
  const addPackageToCart = useAddToCart();
  const removePackageFromCart = useRemoveFromCart();
  const selected = useContainPackage(packageData.id);

  function onClick() {
    return selected ? removePackageFromCart(packageData.id) : addPackageToCart(packageData);
  }

  const getSegmentClassName = (isTextCenter: boolean = false) =>
    classNames(
      'border-b-2 p-3',
      { 'text-center': isTextCenter },
      { 'border-green-200': selected },
      { 'border-yellow-200': !selected && !packageData.status },
      { 'border-rose-200': !selected && packageData.status && packageData.price === 0 }
    );

  return (
    <div
      className={classNames(
        'm-4 flex flex-col rounded-lg border-2 shadow-sm',
        { 'border-blue-200 bg-blue-50': selected },
        { 'border-yellow-200 bg-yellow-50': !selected && !packageData.status },
        {
          'border-rose-200 bg-rose-50': !selected && packageData.status && packageData.price === 0
        },
        {
          'border-green-200 bg-green-50':
            !selected && packageData.status && packageData.price > 0 && packageData.examCount > 1
        },
        { 'bg-gray-50': !selected && packageData.status && packageData.price !== 0 },
        'transition delay-150 duration-300 ease-in-out',
        { '-translate-y-1 scale-105 transform-gpu': selected }
      )}
    >
      <div className={getSegmentClassName()}>
        <p className='text-center font-medium'>{packageData.name}</p>
      </div>

      {packageData.examCount > 1 && (
        <div className={classNames(getSegmentClassName(), 'flex flex-col')}>
          <p className='p-1'>
            <span className='font-medium'>آزمون‌ها: </span>
          </p>
          {packageData.exams.map(
            (exam, index) =>
              (showMore || index <= 2) && (
                <p key={exam.id} className='p-1'>{`${index + 1}. ${exam.name}`}</p>
              )
          )}

          {packageData.exams.length > 3 && (
            <button onClick={() => setShowMore(!showMore)} className='py-1 px-4'>
              بیشتر
            </button>
          )}
        </div>
      )}

      {packageData.discountPercent !== 0 && (
        <div className={getSegmentClassName(true)}>
          <Field title='تخفیف' content={`%${packageData.discountPercent}`} />
        </div>
      )}

      <div className={classNames(getSegmentClassName(true), 'flex-grow')}>
        <Field title='توضیحات' content={packageData.description || BLANK_TEXT} />
      </div>
      <div className={getSegmentClassName(true)}>
        <Field
          title='قیمت'
          content={packageData.price ? `${packageData.price.toLocaleString()} ریال` : 'رایگان'}
        />
      </div>
      <div className='p-3'>
        <Button
          color={selected ? 'red' : 'green'}
          colorWeight={400}
          onClick={onClick}
          className='m-auto'
          content={selected ? 'حذف از سبد خرید' : 'افزودن به سبد خرید'}
        />
      </div>
    </div>
  );
}

export default Package;
